export const statuses = [
  "Order Complete",
  "Order Received",
  "On Hold",
  "In Design",
  "Waiting Confirmation",
  "In Printing",
  "Ready for Pick-up",
  "Waiting Payment",
  "Waiting quote"
];
export default number => {
  return statuses[parseInt(number) - 1];
};
